var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 10.316a.941.941 0 0 1 1.33 0l5.02 5.02a.941.941 0 0 1 0 1.33l-5.02 5.019a.941.941 0 0 1-1.33-1.33l3.412-3.414H9.726a.941.941 0 0 1 0-1.882h10.276l-3.411-3.413a.941.941 0 0 1 0-1.33Z",
    fill: "#D70000"
  })));
};
export default SvgRightArrow;